import React from "react";

import { Grid } from "@mui/material";
import { generateQuantityButtonWidgetForPreview } from "@src/components/ColorAndStyle/utils/utils";
import { offerExample } from "@src/domains/WidgetLibrary/stubs";
import { useSelector } from "@src/store";
import { getLibraryQuantityButtonsList } from "@src/store/slices/widgets/selectors";
import { GlobalStylesQuantityButtonsVariantList } from "@src/types/widgetVariants";

import { QuantityButtonsFullPageDialog } from "./QuantityButtonsFullPageDialog";
import { QuantityButtonsPreview } from "./QuantityButtonsPreview";

export const QuantityButtonsOverview = () => {
  const widgets = useSelector(getLibraryQuantityButtonsList).filter(
    (widget) => {
      const variant = widget.config.desktop?.variant;
      return (
        // @ts-ignore - GlobalStylesQuantityButtonsVariantList is the now supported variants
        variant && GlobalStylesQuantityButtonsVariantList.includes(variant)
      );
    }
  );

  return (
    <Grid
      container
      direction={"column"}
      alignItems={"flex-end"}
      rowSpacing={2}
      columnSpacing={2}
    >
      <Grid item container direction={"row"} rowSpacing={4} columnSpacing={4}>
        {widgets.map((widget) => (
          <QuantityButtonsPreview
            key={widget.id}
            gridSx={{
              width: "330px",
            }}
            widget={generateQuantityButtonWidgetForPreview(widget)}
            offer={offerExample}
          />
        ))}
      </Grid>
      <QuantityButtonsFullPageDialog />
    </Grid>
  );
};
